import React from 'react'
import '../assets/styles/components/_login.scss'
import LoginClienteCard from '../components/loginCliente/LoginClienteCard';
import { Helmet, HelmetProvider } from "react-helmet-async";

const LoginCliente = () => {
  return (
    <div className="login-cliente__page">
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>Sección Clientes Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón</title>
          <meta name="title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta name="description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta itemProp="image" content="https://tensolite.com/images/redes.png" />
          <meta name="author" content="Sitenso"></meta>

          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://tensolite.com`} />
          <meta property="og:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="og:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="og:image" content="https://tensolite.com/images/redes.png" />

          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`https://tensolite.com`} />
          <meta property="twitter:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="twitter:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="twitter:image" content="https://tensolite.com/images/redes.png" />
        </Helmet>
      </HelmetProvider>
      <div className='container'>
      <LoginClienteCard />
      </div>
      {/* <SignUpCard /> */}
    </div>
  )
}

export default LoginCliente
